import { render, staticRenderFns } from "./ImprestExpenseItemsTable.vue?vue&type=template&id=98482b26"
import script from "./ImprestExpenseItemsTable.vue?vue&type=script&lang=js"
export * from "./ImprestExpenseItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ImprestExpenseItemsTable.vue?vue&type=style&index=0&id=98482b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports